"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOnEnterKeyDown = exports.createOnClickEnterKeyDown = void 0;
/**
 *
 * @param {any} callback
 * @returns {function(React.KeyboardEvent): void}
 */
var createOnEnterKeyDown = function createOnEnterKeyDown(callback) {
  return function (e) {
    if (e.key === 'Enter') {
      callback(e);
    }
  };
};

/**
 *
 * @param {any} callback
 * @returns {function(React.KeyboardEvent | React.MouseEvent): void}
 */
exports.createOnEnterKeyDown = createOnEnterKeyDown;
var createOnClickEnterKeyDown = function createOnClickEnterKeyDown(callback) {
  return function (e) {
    if (e.type === 'click' || e.key === 'Enter') {
      callback(e);
    }
  };
};
exports.createOnClickEnterKeyDown = createOnClickEnterKeyDown;
//# sourceMappingURL=index.js.map